<script context="module">
    import { fetchWithHeaders, getBaseURL, querifiedURL } from "../utils.svelte";
    export async function getMaintenanceDetails(propertyID, maintenanceID, includeProperty = false) {
        const queryParams = {};
        if (includeProperty) {
            queryParams.includeProperty = 1;
        }
        return await fetchWithHeaders(querifiedURL(getBaseURL() + '/properties/' + propertyID + '/maintenances/' + maintenanceID, queryParams));
    }

    export async function getAllMaintenances() {
        return await fetchWithHeaders(getBaseURL() + '/maintenances');
    }
    
    export async function deleteMaintenance(propertyID, maintenanceID) {
        return await fetchWithHeaders(getBaseURL() + '/properties/' + propertyID + '/maintenances/' + maintenanceID, {
            method: 'DELETE'
        });
    }

    export async function createMaintenance(propertyID, maintenanceData) {
        return await fetchWithHeaders(getBaseURL() + '/properties/' + propertyID + '/maintenances', {
            method: 'POST',
            body: maintenanceData
        });
    }

    export async function updateMaintenance(propertyID, maintenanceID, maintenanceData) {
        return await fetchWithHeaders(getBaseURL() + '/properties/' + propertyID + '/maintenances/' + maintenanceID + '/update', {
            method: 'POST',
            body: maintenanceData
        });
    }
</script>
